export default "__VITE_ASSET__h_E2Wipa__"